import PropTypes from 'prop-types'
import { Typography, IconButton } from 'ui-components-web'
import { addMonths } from 'date-fns/addMonths'
import { format } from 'date-fns/format'

import { RightArrow } from 'components/UI/svgIcons'
import useStyles from './styles'

const MonthSlider = ({ date, setDate }) => {
  const classes = useStyles()

  return (
    <div className={classes.monthSliderContainer}>
      <Typography variant={'h5'} color={'inherit'} className={classes.currentMonthLabel}>
        {format(date, 'MMMM y')}
      </Typography>
      <div className={classes.monthActions}>
        <IconButton color={'inherit'} className={classes.prevMonthButton} onClick={() => setDate(addMonths(date, -1))}>
          <RightArrow />
        </IconButton>

        <IconButton color={'inherit'} onClick={() => setDate(addMonths(date, 1))}>
          <RightArrow />
        </IconButton>
      </div>
    </div>
  )
}
MonthSlider.propTypes = {
  date: PropTypes.instanceOf(Date).isRequired,
  setDate: PropTypes.func.isRequired,
}

export default MonthSlider
